import { Controller } from 'react-hook-form'
import { usePatientFormContext } from '../../context/PatientFormContext'

import { patientFormErrors } from '../../_errors'
import { useFormContextPatient } from '../_utils'
import PatientFormField from '../PatientFormField'
import { cleanAccentsAndDiacritics } from '../../../../utils/stringUtils'

const BirthName = () => {
    const { control } = useFormContextPatient()
    const {
        state: { isDisabled },
    } = usePatientFormContext()

    return (
        <Controller
            control={control}
            name="birthName"
            rules={{
                required: patientFormErrors.birthName?.required,
                validate: (val) => (val?.trim().length ?? 0) > 0,
            }}
            render={({ field, fieldState: { error } }) => (
                <PatientFormField
                    variant="input"
                    label="Nom de naissance"
                    disabled={isDisabled}
                    required
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    onKeyDown={(event) => {
                        const cleanInput = cleanAccentsAndDiacritics(String(field.value?.toUpperCase()))
                        event.currentTarget.value = cleanInput
                    }}
                    {...field}
                    dataCyScope="PatientField"
                    value={cleanAccentsAndDiacritics(String(field?.value?.toUpperCase() ?? ''))}
                    placeholder="Nom de naissance"
                />
            )}
        />
    )
}

export default BirthName
